import React, { Component } from 'react';
import { connect }                  from 'react-redux';
import ReactTooltip                 from 'react-tooltip';
import { Link }                     from 'react-router-dom'
import { Scrollbars }               from 'react-custom-scrollbars';
import { SetByAceitarRecusarDuelo, 
         GetDuelosAbertos,
        SetIdDuelo }                from '../../../actions/batalhaAction';
import Avata_m                      from '../../../container/render_avatar_p';
import FlashCarregando              from '../../../container/FlashCarregando';
import {SetError}                   from '../../../actions/authenticActions';
import load           from "../../../img/load/load.gif";
import img_batalha_inicio           from "../../../img/batalha/aviso_nao_iniciou_batalha.png";

class Batalha_Aberto extends Component {

    constructor(props){
       
        super(props);
        this.state = { 
                       duelosAbertos      : [],
                       font_desafiante    : {color:'#333'},
                       font_desafiado     : {color:'#333'},
                       simbolo_desafiante : "",
                       simbolo_desafiado  : "",
                       borde_desafiante   : {border:'3px #ccc solid'},
                       borde_desafiado    : {border:'3px #ccc solid'},
                       load               : false

                    };

       // this.getRenderDuelosAbertos = this.getRenderDuelosAbertos.bind(this);
    }

    componentWillMount() {
      
        this.props.GetDuelosAbertos(this.props.session.id).then((response) => {
          this.setState({load:true});
        }).catch((error) =>{
         this.props.SetError(500);
        });  
    }

    selectionAcaoAceitarRecusarDuelo(due_id,acao){
        this.props.SetByAceitarRecusarDuelo(due_id,acao).then((response) =>{
              this.props.GetDuelosAbertos(this.props.session.id);
        });
    }

    statusDuelo(elem){
      
            var flag_recusado            = elem.dados.due_flag_recusado;
            var due_id                   = elem.dados.due_id;
            var isDesafiante             = elem.dados.isDesafiante;
            var flag_concluiu_desafiado  = (elem.dados.due_ultima_questao_desafiado === this.props.menu.batalha.limitQuestao ) ? 1 : 0;
            var flag_concluiu_desafiante = (elem.dados.due_ultima_questao_desafiante === this.props.menu.batalha.limitQuestao ) ? 1 : 0;
           var lef = {'float':'left','marginRight': '10px'}
            const Aceitar                = <button type="button" style={lef} onClick={this.selectionAcaoAceitarRecusarDuelo.bind(this,due_id,1)} className="action action-corner-points"> <span>Aceitar</span></button>;
            const Recusar                = <button type="button" onClick={this.selectionAcaoAceitarRecusarDuelo.bind(this,due_id,0)} className="action action-corner-points"><span className="shadow">&times;</span></button>;
            const Aguardando             = <button type="button" className="action action-corner-points" disabled="disabled"><span>Com oponente</span></button>;
            const jogando                = <Link to={`${this.props.menu.batalha.aluno.jogo}/${due_id}`} className="action action-corner-points"><span>Jogar</span></Link>;
            const oponente               = <button type="button" className="action action-corner-points" disabled="disabled"><span>Com Oponente</span></button>;

        switch(flag_recusado){

            case null:
            
                return (isDesafiante ? Aguardando : <div>{Aceitar} {Recusar} </div>);
                            
            case 0:

                if(isDesafiante) {
                    //oponente ou jogando
                    return (flag_concluiu_desafiante) ? oponente : jogando;

                } else {
                        //oponente ou jogando
                    return (flag_concluiu_desafiado) ? oponente : jogando;
                }
            default:  
                return"";                  
        }
        
    }

    renderBatalhaAberta(){

        const duelos = this.props.dueloAberto;

        if (duelos.length) {

            return  duelos.map((elem,i) =>{

               return <div className="battle-versus" key={i}>
                        <div className="battle-versus-match">
                            <div className="battle-versus-match-player">
                                <div className="battle-versus-player-avatar"
                                     data-tip
                                     data-for={'desafiante_'+elem.desafiante.use_id}>
                                     <Avata_m Foto={elem.desafiante.use_foto} />
                                  <ReactTooltip
                                        id={'desafiante_'+elem.desafiante.use_id}
                                        place="top"
                                        type="dark"
                                        effect="solid">
                                        {elem.desafiante.use_nome}
                                    </ReactTooltip>
                                </div>
                            </div>
                            <div className="battle-versus-match-x">&times;</div>
                            <div className="battle-versus-match-player">
                                <div className="battle-versus-player-avatar"
                                     data-tip
                                     data-for={'desafiado_'+elem.desafiado.use_id}>
                                     <Avata_m Foto={elem.desafiado.use_foto} />
                                    <ReactTooltip
                                        id={'desafiado_'+elem.desafiado.use_id}
                                        place="top"
                                        type="dark"
                                        effect="solid">
                                        {elem.desafiado.use_nome}
                                    </ReactTooltip>
                                </div>
                            </div>
                        </div>
                        <div className="battle-versus-actions">
                          {this.statusDuelo(elem)}
                        </div>
                    </div>;
            }); 

        }else{

            return <img className="img-responsive img-batalha-default" src={img_batalha_inicio}  alt="Foto"/>;
        }  
     }

    render() {
        return (
               <div className="battle-card-match">
                    <div className="battle-card-match-title">
                        <div className="battle-card-match-title-text">Abertos</div>
                    </div>
                    <div className="battle-card-match-body">
                        <div className="battle-versus-list">
                            {this.state.load ? this.renderBatalhaAberta(): <FlashCarregando/>}                                                                  
                        </div>                                    
                        <div className="battle-card-match-body-decoration"></div>
                    </div>                                
                </div>
        );
    }
}

function mapStateToProps(state) {

    return { 
            session : state.auth.session,
            dueloAberto : state.batalhaReducer.allDueloAberto,
            menu    : state.configReducer.menu,
           }
}
export default connect(mapStateToProps,{ SetByAceitarRecusarDuelo, GetDuelosAbertos, SetIdDuelo, SetError}) (Batalha_Aberto);




// WEBPACK FOOTER //
// ./src/components/aluno/batalha/batalha_abertos.js